"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.is-nan");
require("core-js/modules/es6.set");
var _toConsumableArray2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _defineProperty2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.map");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _pattern = require("@/api/pattern");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    // 模型列表
    patternList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 配置类型列表
    configTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 修改状态列表
    changeStateList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 禁止修改的标识
    forbidModifyFlag: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      rules: {
        checkedTypes: {
          required: true,
          message: '请选择配置类型（可多选）',
          trigger: 'blur'
        },
        changeState: {
          required: true,
          message: '请选择操作类型',
          trigger: 'blur'
        }
      },
      ruleForm: {
        checkedTypes: [],
        changeState: 0 // 0 可修改，1 禁止修改，默认禁止修改
      },
      ratioList: [],
      // 模型比例配置列表
      sRatioList: [],
      // 第二配置模型比例列表
      activeTab: 'content',
      showSContentTab: false,
      canClick: true,
      // 是否可以点击提交按钮
      // 可复用的初始化配置值列表
      initRatioList: [{
        value: '',
        label: '',
        weight: 0,
        fans: 0,
        // 预计加粉
        limit: 0,
        // 上限
        showLimit: false
      }],
      todayOrders: 0 // 今日可导订单（初始值使用昨日可导订单值）
    };
  },
  computed: {
    // 总比例
    totalRatio: function totalRatio() {
      var total = this.computeRatio(this.ratioList);
      return total;
    },
    // 昨日可导订单
    yesterdayOrders: function yesterdayOrders() {
      var _this = this;
      var orders = 0;
      this.ruleForm.checkedTypes.forEach(function (checkedType) {
        var findItem = _this.configTypeList.find(function (item) {
          return item.value === checkedType;
        });
        if (findItem) {
          orders += findItem.canGuideOrders;
        }
      });
      return orders;
    },
    // 所有模型上限和（只统计比例不为0的模型）
    totalLimit: function totalLimit() {
      if (!this.ratioList || this.ratioList.length === 0) {
        return 0;
      }
      var total = 0;
      var _iterator = _createForOfIteratorHelper(this.ratioList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (Number(item.weight || 0) > 0) {
            total += Number(item.limit || 0);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return total;
    },
    sTotalRatio: function sTotalRatio() {
      var total = this.computeRatio(this.sRatioList);
      return total;
    },
    sTotalLimit: function sTotalLimit() {
      if (!this.sRatioList || this.sRatioList.length === 0) {
        return 0;
      }
      var total = 0;
      var _iterator2 = _createForOfIteratorHelper(this.sRatioList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          if (Number(item.weight || 0) > 0) {
            total += Number(item.limit || 0);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return total;
    }
  },
  watch: {
    // 昨日可导订单变更时，更新今日可导订单
    yesterdayOrders: function yesterdayOrders(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.todayOrders = newVal;
      }
    },
    // 今日可导订单发生变更时，更新预计加粉数
    todayOrders: function todayOrders(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateFans();
        this.updateSFans();
      }
    }
  },
  methods: {
    computeRatio: function computeRatio(list) {
      if (!list || list.length === 0) {
        return 0;
      }
      var total = 0;
      var _iterator3 = _createForOfIteratorHelper(list),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          total += Number(item.weight);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      if (total > 100) {
        var message = '总比例已超过100%，请调整！';
        this.$message({
          message: message,
          type: 'warning'
        });
      }
      return total;
    },
    onCancel: function onCancel() {
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.handleEvent();
        } else {
          return false;
        }
      });
    },
    handleEvent: function handleEvent() {
      var valid1 = this.validateRatio(this.ratioList, this.totalRatio);
      if (!valid1.status && valid1.tips) {
        this.$message({
          message: valid1.tips,
          type: 'warning'
        });
        return;
      }
      // 校验特殊配置值（有数据时才校验）
      if (this.sRatioList.length > 0) {
        var valid2 = this.validateRatio(this.sRatioList, this.sTotalRatio);
        if (!valid2.status && valid2.tips) {
          this.$message({
            message: '特殊配置值：' + valid2.tips,
            type: 'warning'
          });
          return;
        }
      }
      if (!this.canClick) {
        this.$message({
          message: '请勿重复提交！',
          type: 'warning'
        });
        return;
      }
      this.canClick = false;
      this.editOneButton();
    },
    /** 校验比例 */validateRatio: function validateRatio(list, totalRatio) {
      if (list.length === 0) {
        return {
          status: false,
          tips: '请配置模型比例！'
        };
      }
      if (totalRatio != 100) {
        return {
          status: false,
          tips: '总比例需为100%，请调整！'
        };
      }
      var seen = new Map();
      var _iterator4 = _createForOfIteratorHelper(list),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var item = _step4.value;
          if (item.value === '') {
            return {
              status: false,
              tips: '请选择模型！'
            };
          }
          if (seen.has(item.value)) {
            return {
              status: false,
              tips: '存在重复模型配置，请检查并修改！'
            };
          }
          seen.set(item.value, item.weight);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return {
        status: true,
        tips: '比例配置正常',
        values: Object.fromEntries(seen)
      };
    },
    // 一键配置
    editOneButton: function editOneButton() {
      var _this3 = this;
      var content = this.getFormatContent(this.ratioList);
      var s_content = this.sRatioList.length > 0 ? this.getFormatContent(this.sRatioList) : '[]';
      var params = {
        class: this.ruleForm.checkedTypes.join(','),
        change_state: this.ruleForm.changeState,
        content: content,
        s_content: s_content
      };
      (0, _pattern.editProductsPatternByOneButton)(params).then(function (_ref) {
        var code = _ref.code;
        if (code === 200) {
          _this3.$message({
            message: '修改成功',
            type: 'success'
          });
          _this3.dialogVisible = false;
          _this3.$parent.getAllPatternList(); // 更新列表
          _this3.canClick = true;
        }
      });
    },
    /** 获取格式化content（接口所需） */getFormatContent: function getFormatContent(list) {
      var content = (list || this.ratioList).map(function (item) {
        var newItem = {
          id: item.value,
          ratios: item.weight,
          o_sum: item.limit,
          expected_fans: item.fans
        };
        return newItem;
      });
      return JSON.stringify(content);
    },
    // 删除一行模型配置
    deletePattern: function deletePattern(listKey, index) {
      this[listKey].splice(index, 1);
    },
    // 添加一行模型配置
    addPattern: function addPattern(listKey) {
      var newItem = _objectSpread({}, this.initRatioList[0]);
      this[listKey].push(newItem);
    },
    /**
     * 配置类型变更处理
     */
    onMultiConfigTypeChange: function onMultiConfigTypeChange() {
      var _this4 = this;
      var newRatioList = [];
      var newSRatioList = [];
      var changeState = 0;
      var ratioList2D = [];
      this.ruleForm.checkedTypes.forEach(function (type) {
        var configItem = _this4.findConfigTypeItem(type);
        if (configItem) {
          if (configItem.changeState === _this4.forbidModifyFlag) {
            changeState = _this4.forbidModifyFlag;
          }
          newRatioList.push.apply(newRatioList, (0, _toConsumableArray2.default)(configItem.ratioList));
          ratioList2D.push(configItem.ratioList);
          if (configItem.sRatioList && configItem.sRatioList.length > 0) {
            newSRatioList.push.apply(newSRatioList, (0, _toConsumableArray2.default)(configItem.sRatioList));
          }
        }
      });
      this.ratioList = this.uniqueByValue(newRatioList);
      this.sRatioList = this.uniqueByValue(newSRatioList);
      this.showSContentTab = this.sRatioList.length > 0;
      this.activeTab = 'content';
      var isSame = this.isAllSame(ratioList2D);
      if (!isSame) {
        setTimeout(function () {
          _this4.$message({
            message: '存在不同模型或比例，请注意检查！',
            type: 'warning'
          });
        }, 500);
      }
      this.ruleForm.changeState = changeState;
      this.updateFans();
      this.updateSFans();
    },
    isAllSame: function isAllSame(arr) {
      if (arr.length < 2) return true;
      var first = JSON.stringify(arr[0]);
      return arr.every(function (subArr) {
        return JSON.stringify(subArr) === first;
      });
    },
    // 模型比例配置去重
    uniqueByValue: function uniqueByValue(arr) {
      var seen = new Set();
      return arr.filter(function (item) {
        var value = item.value;
        if (seen.has(value)) {
          return false;
        }
        seen.add(value);
        return true;
      });
    },
    // 找到对应的配置类型项
    findConfigTypeItem: function findConfigTypeItem(configType) {
      var configTypeItem = null;
      for (var i = 0; i < this.configTypeList.length; i++) {
        var item = this.configTypeList[i];
        if (item.value === configType) {
          configTypeItem = item;
          break;
        }
      }
      return configTypeItem;
    },
    onAddSContent: function onAddSContent() {
      this.showSContentTab = true;
      this.sRatioList = [_objectSpread({}, this.initRatioList[0])];
      this.activeTab = 's_content';
    },
    // 打开上限配置
    openLimitConfig: function openLimitConfig(listKey, index) {
      this.$set(this[listKey][index], 'showLimit', true);
    },
    /**
     * 更新导粉
     * 时机：
     * 1. 可导订单发生变更；
     * 2. 配置类型发生变更；
     * 3. 模型比例发生变更；
     * 4. 模型发生变更；
     */
    updateFans: function updateFans() {
      this._updateFansForList(this.ratioList, 'ratioList');
    },
    updateSFans: function updateSFans() {
      this._updateFansForList(this.sRatioList, 'sRatioList');
    },
    _updateFansForList: function _updateFansForList(list, listKey) {
      for (var i = 0; i < list.length; i++) {
        var ratioItem = list[i];
        if (ratioItem.value !== '') {
          var fans = Math.round(this.todayOrders * (ratioItem.weight / 100) * (ratioItem.fansRate / 100));
          if (typeof fans === 'number' && !Number.isNaN(fans)) {
            this.$set(this[listKey][i], 'fans', fans);
          }
        }
      }
    },
    onSelectChange: function onSelectChange(listKey, ratioIndex) {
      var ratioItem = this[listKey][ratioIndex];
      var findItem = this.patternList.find(function (item) {
        return item.value === ratioItem.value;
      });
      if (findItem) {
        this.$set(this[listKey][ratioIndex], 'fansRate', findItem.fan_rate);
        this.$set(this[listKey][ratioIndex], 'label', findItem.label);
        var limit = findItem.basket && findItem.basket.o_sum ? Number(findItem.basket.o_sum) : 0;
        this.$set(this[listKey][ratioIndex], 'limit', limit);
        if (listKey === 'ratioList') {
          this.updateFans();
        } else {
          this.updateSFans();
        }
      }
    },
    goPatternDetail: function goPatternDetail(id) {
      var findItem = this.patternList.find(function (item) {
        return item.value === id;
      });
      if (findItem) {
        this.$router.push({
          name: 'patternList',
          query: {
            pattern_id: findItem.pattern_product_id
          }
        });
      }
    }
  }
};